import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";
import CredenciadoNavbarLinks from "../Navbars/CredenciadoNavbarLinks";

import logo from "../../assets/img/logo_ramicard.png";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth,
    };
  }

  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }

  updateDimensions() {
    this.setState({ width: window.innerWidth });
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  render() {
    const sidebarBackground = {
      backgroundImage: "url(" + this.props.image + ")",
    };

    const getCredenciadoFromLocalStorage = () => {
      let result = ''
      if ( localStorage.getItem("Credenciado") ) {
        result = localStorage.getItem("Credenciado").toUpperCase()
      }
  
      return result
    }

    return (
      <div
        id="sidebar"
        className="sidebar"
        data-color={this.props.color}
        data-image={this.props.image}
      >
        {this.props.hasImage ? (
          <div className="sidebar-background" style={sidebarBackground} />
        ) : null}
        <div className="logo">
          <a href="/credenciado/servicos" className="simple-text logo-mini">
            <div className="logo-img">
              <img
                src={logo}
                alt="Rufus_Ramicard"
                style={{ width: "40px", marginTop: "6px" }}
              />
            </div>
          </a>
          <div
            style={{ fontSize: "22px", display: "flex", fontFamily: "Roboto" }}
          >
            Ramicard
          </div>
          <div style={{ fontSize: 14 }}>{`${String(
            localStorage.getItem("Credenciado")
          ).slice(0, 18)}`}</div>
        </div>
        <div className="sidebar-wrapper">
          <ul className="nav">
            {this.state.width <= 991 ? <CredenciadoNavbarLinks /> : null}

            {this.props.routes.map((prop, key) => {
              if (!prop.redirect)
                return (
                  <li
                    className={
                      prop.upgrade
                        ? "active-pro"
                        : this.activeRoute(prop.layout + prop.path)
                    }
                    key={key}
                  >
                    {prop.path === '/suporte' ? <Link to={{
                      pathname: `https://api.whatsapp.com/send?phone=5515996058530&text=Sou%20o%20credenciado%20${getCredenciadoFromLocalStorage()}%2C%20poderiam%20me%20ajudar?`
                    }} target="_blank" >
                      {<>
                        <i className={prop.icon} />
                        <p>{prop.name}</p>
                      </>}
                    </Link> :
                      <NavLink
                        to={prop.layout + prop.path}
                        className="nav-link"
                        activeClassName="active"
                      >
                        {<>
                          <i className={prop.icon} />
                          <p>{prop.name}</p>
                        </>}
                      </NavLink>
                    }
                  </li>
                );
              return null;
            })}
          </ul>
        </div>
      </div>
    );
  }
}

export default Sidebar;
